import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasFieldOptionSchema = withDefaults({
  type: 'tas-field-option',
  fields: [
    {
      kind: 'attribute',
      name: 'fieldName',
    },
    {
      kind: 'attribute',
      name: 'value',
    },
    {
      kind: 'attribute',
      name: 'label',
    },
    {
      kind: 'attribute',
      name: 'valueType',
    },
    {
      kind: 'attribute',
      name: 'ordinal',
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramTemplate',
      type: 'tas-program-template',
      options: {
        async: false,
        inverse: 'tasFieldOptions',
      },
    },
  ],
});

export default TasFieldOptionSchema;
